import { EvidencePlatformSidebarAppID, OrganizationsPageTab } from '@verantos-dev/core-enums';

import { PAGE_TABS_URL_PARAM } from './routingConstants';

export const ORGANIZATIONS_BASE_PATH = EvidencePlatformSidebarAppID.organizations;
export const ORGANIZATIONS_CUSTOMERS_PATH = OrganizationsPageTab.customers;
export const ORGANIZATIONS_RESEARCH_PARTNERS_PATH = OrganizationsPageTab.researchPartners;
export const ORGANIZATIONS_VERANTOS_PATH = OrganizationsPageTab.verantos;

export const getOrganizationsBasePath = () => `/${ORGANIZATIONS_BASE_PATH}`;

export const getOrganizationsCustomersPath = () =>
  `${getOrganizationsBasePath()}?${PAGE_TABS_URL_PARAM}=${ORGANIZATIONS_CUSTOMERS_PATH}`;

export const getOrganizationsResearchPartnersPath = () =>
  `${getOrganizationsBasePath()}?${PAGE_TABS_URL_PARAM}=${ORGANIZATIONS_RESEARCH_PARTNERS_PATH}`;

export const getOrganizationsVerantosPath = () =>
  `${getOrganizationsBasePath()}?${PAGE_TABS_URL_PARAM}=${ORGANIZATIONS_VERANTOS_PATH}`;
